import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CheckoutForm from "../components/CheckoutForm";
import CartItemsCheckout from "../components/CartItemsCheckout";
import useSubmitBooking from "../Hooks/useSubmitBooking";
import { useNavigate } from "react-router-dom";

const CheckoutPage = ({ cart }) => {
  const { items } = cart;
  const [saveInfo , setSaveInfo] = useState(true)
  const navigate = useNavigate();
  // Calculate subtotal
  const subtotal = items.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  useEffect(()=>{
    if(items.length <= 0){
      navigate("/");
    }
  },[items])
  // Shipping state
  const [shipping, setShipping] = useState(0);

  // Total calculation
  const total = subtotal + shipping;
  
  const [formData, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    address: "",
    city: "",
    postal_code: "",
    phone: "",
    payment_method: "",
    shipping_method: "courier_services",
    billing_address: "",
    billing_address_country: "Pakistan",
    billing_address_first_name: "",
    billing_address_last_name: "",
    billing_address_address: "",
    billing_address_apartment: "",
    billing_postal_code: "",
    billing_city: "",
    billing_phone: "",
    discount_code: "",
    order_items: items.map((item) => ({
      product: item.id,
      quantity: item.quantity,
      size: item.size || "",
    })),
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const { submitBooking, loading, error, success } = useSubmitBooking();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const bookingData = { ...formData, order_items: formData.order_items };
    await submitBooking(bookingData,saveInfo);
  };

  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
        <div className="col-span-2 container md:ps-24 md:pe-8 md:pb-28 pb-8">
          {/* Form Section */}
          <CheckoutForm
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            loading={loading}
            error={error}
            success={success}
            saveInfo={saveInfo}
            setSaveInfo={setSaveInfo}
            setShipping={setShipping}
            setFormData={setFormData}
          />
        </div>
        <div className="bg-gray-50 p-6 border col-span-2 border-gray-200 space-y-6 md:pe-28 md:ps-8">
          <CartItemsCheckout
            formData={formData}
            handleInputChange={handleInputChange}
            items={items}
            subtotal={subtotal}
            total={total}
            shipping={shipping}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cart: state.cart,
});

export default connect(mapStateToProps)(CheckoutPage);
